module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_04-Research_active.574b8501.png";